import { put, takeLatest } from 'redux-saga/effects';

import { requestLocations } from '../../../services/Locations';
import { fetchLocationsFailure, fetchLocationsSuccess } from '../../actions/Locations/location-list';
import { FETCH_LOCATIONS_REQUEST } from '../../actions/Locations/types';

export function* watchLocations() {
    yield takeLatest(FETCH_LOCATIONS_REQUEST, fetchLocations);
}

/**
 * @typedef {Object} PAYLOAD
 * @property {number} skip
 *
 * @typedef {Object} PARAMS
 * @property {PAYLOAD} payload
 *
 */

/**
 *
 * @param {PARAMS} param0
 */
function* fetchLocations({ payload }) {
    try {
        const response = yield requestLocations(payload);
        yield put(fetchLocationsSuccess(response));
    } catch (error) {
        yield put(
            fetchLocationsFailure('Failed to get list of Locations')
        );
    }
}
